import { GetListRes } from './GetListRes';

export enum TableColumnKey {
  OrderId = 'orderId',
  ApprovalProgress = 'approvalProgress',
  PfhNo = 'pfhNo',
  ClientName = 'clientName',
  CreditCurrency = 'creditCurrency',
  CreditAmount = 'creditAmount',
  Status = 'status',
  CreatedBy = 'createdBy',
  CreationTime = 'creationTime',
  LastModifiedTime = 'lastModifiedTime',
}

export interface TableRow {
  id: number;
  [TableColumnKey.OrderId]?: string;
  [TableColumnKey.ApprovalProgress]?: string;
  [TableColumnKey.PfhNo]?: string;
  [TableColumnKey.ClientName]?: string;
  [TableColumnKey.CreditCurrency]?: string;
  [TableColumnKey.CreditAmount]?: string;
  [TableColumnKey.Status]?: string;
  [TableColumnKey.CreatedBy]?: string;
  [TableColumnKey.CreationTime]?: string;
  [TableColumnKey.LastModifiedTime]?: string;
  rawData?: GetListRes;
}
